import { PageHeader } from '@/shared/components/PageHeader';
import { Wrench } from 'lucide-react';
import DisciplinesStep from '../components/DisciplinesStep';

export default function DisciplinesPage() {
  return (
    <div className="h-full flex flex-col bg-background overflow-hidden">
      <PageHeader
        title="Disciplines"
        subtitle="Manage trades and disciplines"
        icon={<Wrench className="w-7 h-7" style={{ color: '#E84A2B' }} />}
      />
      <div className="flex-1 overflow-y-auto px-6 pb-6 pt-2">
        <DisciplinesStep />
      </div>
    </div>
  );
}
